// extracted by mini-css-extract-plugin
export default {"modalWrapper":"modal_modalWrapper__lAf4D","modalContentWrapper":"modal_modalContentWrapper__W99nz","body":"modal_body__SQUnU"};